import React from 'react'
import CallUs from '../components/Callus'
import { Marginer } from '../components/marginer'
import { Navbar } from '../components/navbar'
import { SectionTitle } from '../components/sectionTitile'
import styled from 'styled-components'
import theme from '../themes'
import AboutusImage from '../tools/pictures/computerr.jpg'
import { Button } from 'react-scroll'
import Btn from '../components/button'
import Navigation from '../navigation'
import { NavLink } from 'react-router-dom'
import ContactUs from '../components/emailsend'
import { Footer } from '../components/footer'

const TopContainer = styled.div`
width:100%;
height:100vh;
background-image:url(${AboutusImage});
background-repeat:no-repeat;
background-size:cover;
`;
// const Filter = styled.div`
// width:100%;
// height:100%;
// background-color:rgba(55, 55, 55, 0.90);
// `;

const ButtonStyle = styled(Btn)`
margin-left:1rem;

@media screen and (max-width:580px){
    margin-bottom:1rem;
}
`;


const Paragraph = styled.p`
color:${theme.black};
font-size:1.2rem;
/* margin-left:1rem; */
padding:1rem;
width:100%;


@media screen and (max-width:580px){
    width:100%;
    font-size:1rem;
}

`;

const SectionTitleStyle = styled(SectionTitle)`
margin-left:1rem;
text-align:center;
`;

const SectionContainer = styled.div`
display:flex;

@media screen and (max-width:580px){
    flex-direction:column;
}

`;

const Imagee = styled.img`
width:50%;

@media screen and (max-width:580px){
    width:100%;
}
`;

const Bt = styled.button`
`


function About(){
    return(
        <div>
        <Navbar />
        <CallUs />
        {/* <Marginer direction="vertical" margin="2rem"/> */}
        <TopContainer>
            {/* <Filter> */}
            <SectionTitleStyle>About us </SectionTitleStyle>

        <p style={{padding:"1rem",width:"100%",color:"#000080"}}>
                <b>Tecspot</b> is a Lagos Nigeria based web development company that focus
                on design and development of websites that is awesome and that gives your company
                an edge over other companies.
                <br/><br/>
                Our aim is to give our clients professional soothened websites that helps 
                them get new customers and retain their existing ones thereby growing and developing
                their businesses.
                <br/><br/>
                <b>Tecspot</b> was established in Lagos Nigeria as a Website Design and Development
                Company since 2020 and ever since then have been delivering great websites to its clients.

                <br/><br/>
                We are dedicated to building websites for business owners, entrepreneurs in Lagos
                ,within Nigeria and around the world.

                <br/><br/>
           

          </p>
            <Navigation>
                <NavLink to="/web-design">Check Our websites</NavLink>
            </Navigation>
        {/* </Filter> */}


        </TopContainer>

        <SectionTitleStyle>Responsive Website Design</SectionTitleStyle>

        <Paragraph>
            Responsive website design is a website design term that ensures website is suited to any device on which it is accessed.
            At Tecspot, we have a great cognizance for this and we always make sure that our websites are soothened to all devices on which they are viewed.
        </Paragraph>
       <Footer/>
        
        </div>
    )
}

export default About

